import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const getFiles = (pageNo = 1, pageCount = 10, token) => {
  return axios.get(`Community/GetAllAttachment/${pageNo}/${pageCount}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const searchFiles = (
  pageNumber = 1,
  pageSize = 10,
  communityId ,
  data = {},
  token
) => {
  return axios.post(
    `Community/SearchAttachment/${pageNumber}/${pageSize}?communityId=0`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
